import gql from 'graphql-tag';

export default gql`
  query courseLearningAnswers(
    $courseId: String!
    $contentId: String
    $mark: String
    $step: String
  ) {
    course(id: $courseId) {
      learningAnswers(contentId: $contentId, mark: $mark, step: $step) {
        content
        contentId
        step
        mark
      }
    }
  }
`;
